export enum EGender {
  MALE = 'male',
  FEMALE = 'female'
}